import { TabGroup, TabPanel, TabPanels } from "@headlessui/react";
import React, { Fragment, useState } from "react";
import TwTabs from "./TwTabs";

export default function TwTabContainer(props) {
  const { children, className = "", tabsClassName = "", tabs = [
    // { name: 'My Account', key: 'myAccount', onClick: () => { }, icon: UserIcon, current: false, tabPanelComponent: (<>My Account Content</>) },
    // { name: 'Company', key: 'company', onClick: () => { }, icon: BuildingOfficeIcon, current: false, tabPanelComponent: (<>Company</>) },
    // { name: 'Team Members', onClick: () => { }, icon: UsersIcon, current: true },
    // { name: 'Billing', onClick: () => { }, icon: CreditCardIcon, current: false },
  ], allowTabclick = true } = props

  const [tabList, setTabList] = useState([]);
  const [selectedTab, setSelectedTab] = useState("");
  // const tabList = tabs.length > 0 ? tabs.filter((d) => d.name !== undefined).map((d) => {
  //   return {
  //     key: d.name.replace(/\s+/g, '-').toLowerCase(),
  //     ...d,
  //   }
  // }) : []

  const getTabPanelComponents = (index) => {
    return tabList.length > 0 ? tabList.filter((d) => d.tabPanelComponent !== undefined) : []
  };

  const handleTabChange = (index) => {
    if (allowTabclick) {
      setSelectedTab(tabList[index].key);
      if (tabList[index]?.onClick) {
        tabList[index].onClick()
      }
    }
  };

  React.useEffect(() => {
    if (props?.setSelectedTab && props?.selectedTab && props?.selectedTab !== selectedTab) {
      props?.setSelectedTab(props?.selectedTab && props?.selectedTab !== "" && selectedTab === "" ? props?.selectedTab : selectedTab)
    }
  }, [selectedTab, props]);

  React.useEffect(() => {
    if (props?.selectedTab && props?.selectedTab !== selectedTab) {
      setSelectedTab(props?.selectedTab)
    }
  }, [props.selectedTab]);

  React.useEffect(() => {
    let tempselectedTablist = tabs.length > 0 ? tabs.filter((d) => d.name !== undefined).map((d) => {
      return {
        key: d.name.replace(/\s+/g, '-').toLowerCase(),
        ...d,
      }
    }) : []
    setTabList(tempselectedTablist)
    let tempselectedTab = props?.selectedTab ? props.selectedTab : (tempselectedTablist.length > 0 ? tempselectedTablist[0].key : "")
    setSelectedTab(tempselectedTab)
  }, []);
  // console.log("tabList", tabList);
  // console.log("selected", selectedTab);


  return (
    <TabGroup selectedIndex={tabList.findIndex((tab) => tab.key === selectedTab)} onChange={handleTabChange} className={className}>
      <TwTabs
        {...props}
        className={tabsClassName}
        tabs={tabList}
        selectedTab={selectedTab}
        setSelectedTab={setSelectedTab}
        allowTabclick={allowTabclick}
      />
      {children ? children : getTabPanelComponents().length > 0 && (<TabPanels as={Fragment}>
        {getTabPanelComponents().map((d) => {
          return (<TabPanel key={d.key}>
            {d.tabPanelComponent}
          </TabPanel>)
        })}
      </TabPanels>)}
    </TabGroup>
  );
}
